import { Anchor, Box, type BoxProps, Flex, Text } from '@mantine/core'
import { QRCodeSVG } from 'qrcode.react'

import { useDocumentState } from '../../hooks/useDocumentState'
import { SectionTable } from './SectionTable'

export type SectionFooterProps = BoxProps

export function SectionFooter({ ...props }: SectionFooterProps) {
  const { documentPreview, bookingPublicLink, translate } = useDocumentState()

  return (
    <>
      {documentPreview?.booking_settings
        ?.documents_proforma_include_payment_details && (
        <SectionTable {...props}>
          <SectionTable.Header>
            <Text size='md' fw='500' mt='md' c='gray.7'>
              {translate?.('title_payment_details')}
            </Text>
          </SectionTable.Header>
          <SectionTable.Body>
            <Text size='md'>
              {
                documentPreview?.booking_settings
                  ?.documents_proforma_payment_details
              }
            </Text>
          </SectionTable.Body>
        </SectionTable>
      )}
      {documentPreview?.booking_settings?.documents_proforma_include_links && (
        <Flex gap='lg' {...props} align='flex-end'>
          <Box ml='xs'>
            <QRCodeSVG value={bookingPublicLink ?? ''} size={100} />
          </Box>
          <Flex direction='column'>
            <Flex gap='xs'>
              <Text size='md'>{translate?.('label_access_via_link')}</Text>
              <Anchor
                href={bookingPublicLink}
                target='_blank'
                rel='noreferrer'
                underline='always'
                size='md'
                c='text.color'
              >
                {translate?.('label_link')}
              </Anchor>
            </Flex>
            <Text data-testid='qrcode' display='block' size='md'>
              {translate?.('label_access_via_qrcode')}
            </Text>
          </Flex>
        </Flex>
      )}
    </>
  )
}
